import React from 'react';

import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ItemCategory, useGetItemCategoriesQuery } from '../../../redux/vmsApi';

const ItemCategoriesList: React.FC = () => {
  const { data: itemCategories, isLoading, isError } = useGetItemCategoriesQuery({});

  if (isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return <div>Error fetching itemCategories.</div>;
  }

  return (
    <Box p={10}>
      <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        View Item Categories
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Category Code</TableCell>
              <TableCell>Description</TableCell>
             
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {itemCategories?.map((itemCategory: ItemCategory) => (
              <TableRow key={itemCategory.id}>
                <TableCell>{itemCategory.categoryCode}</TableCell>
                <TableCell>{itemCategory.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
     
    </Box>
  );
};

export default ItemCategoriesList;
